export const Filter = {
  Name: "name" as const,
  Description: "description" as const,
  CounterPart: "counterPart" as const,
  Active: "active" as const,
  AgreementPeriod: "agreementPeriod" as const,
  MonthlyCostPeriod: "monthlyCostPeriod" as const,
  TotalCostPeriod: "totalCostPeriod" as const,
}

export const Create = {
  Name: "name" as const,
  Description: "description" as const,
  AgreementPeriod: "agreementPeriod" as const,
  EndsLast: "endsLast" as const,
  Start: "start" as const,
  End: "end" as const,
  Notice: "notice" as const,
  NoticeMonths: "noticeMonths" as const,
  MonthlyCost: "monthlyCost" as const,
  CounterPart: "counterPart" as const,
  CounterPartOrgNr: "counterPartOrgNr" as const,
  Active: "active" as const,
  FilesToUpload: "filesToUpload" as const,
  AttachmentName: "attachmentName" as const,
}

